<template>
  <div class="sortable-item sortable-item-iframevideo width-100-pr">
    <span class="sortable-item-info">
      <span class="sortable-item-type">
        Video <span class="sortable-item-type-position">( {{ index + 1 }} )</span>
      </span>
      <span class="sortable-item-action sortable-item-move">
        <i class="far fa-arrows-alt"></i>
      </span>
      <a
        class="sortable-item-action sortable-item-delete"
        href="#"
        @click.prevent="deleteBlock"
      >
        <i class="far fa-trash-alt"></i>
      </a>
    </span>
    <div class="sortable-item-tag">
      <div
        v-if="$utils.showNativePlayer(block.data.embed)"
        class="videoWrapper"
      >
        <video controls>
          <source
            :src="block.data.embed"
            type="video/mp4"
          >
          Su navegador no soporta la reproducción de este video.
        </video>
      </div>
      <div
        v-else
        class="iframeWrapper"
      >
        <iframe
          :src="block.data.embed"
          webkitallowfullscreen
          mozallowfullscreen
          allowfullscreen
        >
        </iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeContentEditorBlockIframeVideo',

  props: {
    block: Object,
    canEdit: {
      type: Boolean,
      default: true
    },
    index: Number,
    time: {
      type: Number,
      default: null
    }
  },

  computed: {
    showNativePlayer () {
      return true
    }
  },

  methods: {
    deleteBlock () {
      if (this.canEdit) {
        this.$emit('deleteBlock', this.index)
      }
    }
  }
}
</script>
